import posthog from "posthog-js";

export default {
  install(app) {
      if (import.meta.env.PROD && !import.meta.env.SSR) {
          app.config.globalProperties.$posthog = posthog.init(
          'phc_EjFYl0bhlIXvEhguLqwPtW2lXuUAF02uwdhxf2UJ8KN',
          {
            api_host: 'https://us.i.posthog.com',
          }
        );
      }
  },
};
